export default __webpack_public_path__ + "static/media/godsClosed.c46da740.jpg";